import * as t from "io-ts"

export const TSeason = t.interface({
  code: t.string,
  startDate: t.string,
  endDate: t.string
})

export const TSeasons = t.array(TSeason)

export type Season = t.TypeOf<typeof TSeason>
export type Seasons = t.TypeOf<typeof TSeasons>
